import { useTranslate } from "@/hooks";
import { BlockWithLabel } from "@/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Condition from "../Condition/Condition";
import styles from "./ConditionOr.module.scss";
import { faGripVertical, faSitemap } from "@fortawesome/free-solid-svg-icons";
import { selectHintsEnabled } from "@/store/hintsSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { FC } from "react";
import { IConditionOr } from "./ConditionOr.props";
import { useConditionDragDrop } from "../useDragNDrop";
import { selectEndpointElem } from "@/store/ses/sesItemConfigSlice";

const ConditionOr: FC<IConditionOr> = ({
	conditionData,
	conditionBlockIdx,
	conditionIdx,
	isDisable,
	changeFlgHandler,
	conditionFor,
	showDragIcon,
	isConditionReady,
	setIsConditionReady,
	// isThisOrBlock,
	// orBlockIndex,
	// conditionWithOrOption,
	// dragIdx,
	addConditionRunHandler,
	dataElemListOptions,
}) => {
	const translate = useTranslate();
	const hintEnabled = useAppSelector(selectHintsEnabled);
	const dispatch = useAppDispatch();
	const endpointElem = useAppSelector(selectEndpointElem); // store - конечная точка

	const ref = useConditionDragDrop({
		conditionIdx,
		conditionBlockIdx,
		conditionFor,
		changeFlgHandler,
		dispatch,
		endpointElem,
		conditionWithOrOption: false,
		conditionEntryIdx: "conditionEntryBlockIdx" in conditionFor ? conditionFor.conditionEntryBlockIdx : null,
	});

	return (
		<div
			key={conditionData.type + conditionBlockIdx + conditionIdx + (conditionFor.for === "categoryAction" && conditionFor.categoryId)}
			className={styles.orConditionBlock}
			ref={ref}
		>
			<div className={styles.orConditionBlockIconsBlock}>
				{showDragIcon && (
					<div onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()} className={styles.dragIconWrapper}>
						<FontAwesomeIcon
							onClick={(e) => {
								e.stopPropagation();
							}}
							icon={faGripVertical}
							size="xl"
						/>
					</div>
				)}
				<div className={styles.orConditionBlockIcon}>
					<FontAwesomeIcon icon={faSitemap} style={{ fontSize: "12px" }} color="rgb(145, 140, 140)" />
				</div>
			</div>

			<BlockWithLabel
				label={translate("title_blockOr")}
				className={styles.orConditionBlockContainer}
				labelButton={
					<button
						type="button"
						onClick={() => addConditionRunHandler(conditionBlockIdx, null, conditionIdx)}
						title={hintEnabled ? "" : translate("button_addCondition")}
						className={isConditionReady ? styles.appearance : styles.legendButton}
						style={{ padding: "0 6px" }}
					>
						<>+</>
					</button>
				}
			>
				{/* блоки И */}

				<div className={styles.orConditionBlockList}>
					{conditionData.value.map((conditionsArray, conditionsArrayIdx) => {
						if (!conditionsArray) return null;
						return (
							<Condition
								conditionData={conditionsArray}
								conditionBlockIdx={conditionBlockIdx}
								conditionIdx={conditionIdx}
								isDisable={isDisable}
								changeFlgHandler={changeFlgHandler}
								conditionFor={conditionFor}
								showDragIcon={(conditionFor.for === "endpointRunInEntry" || conditionFor.for === "dataElemSlaveData") && !isDisable}
								isConditionReady={isConditionReady}
								setIsConditionReady={setIsConditionReady}
								// isThisOrBlock={isThisOrBlock}
								orBlockIndex={conditionsArrayIdx}
								dragIdx={conditionsArrayIdx}
								key={
									conditionsArray.type +
									(conditionsArray.type !== "break" && conditionsArray.type !== "confirmation" ? conditionsArray.id : "break") +
									conditionBlockIdx +
									conditionsArrayIdx +
									conditionIdx +
									(conditionFor.for === "categoryAction" && conditionFor.categoryId)
								}
								conditionWithOrOption={false}
								dataElemListOptions={dataElemListOptions}
							/>
						);
					})}
				</div>
			</BlockWithLabel>
		</div>
	);
};

export default ConditionOr;
